import { getSubstituteFont } from './font-mapping.js';
export function getFontStack(fontFamily) {
    if (!fontFamily) {
        return 'Arial, sans-serif';
    }
    return getSubstituteFont(fontFamily);
}
export function parseFontSize(htmlContent, defaultSize = 12) {
    if (!htmlContent) {
        return defaultSize;
    }
    const match = htmlContent.match(/font-size:\s*(\d+(?:\.\d+)?)pt/);
    if (match) {
        return parseFloat(match[1]);
    }
    return defaultSize;
}
export function parseFontFamily(htmlContent) {
    if (!htmlContent) {
        return undefined;
    }
    const match = htmlContent.match(/font-family:\s*([^;'"]+)/);
    if (match) {
        return match[1].trim();
    }
    return undefined;
}
export function isBold(htmlContent) {
    if (!htmlContent) {
        return false;
    }
    return htmlContent.includes('font-weight: bold') || htmlContent.includes('<b>') || htmlContent.includes('<strong>');
}
export function isItalic(htmlContent) {
    if (!htmlContent) {
        return false;
    }
    return htmlContent.includes('font-style: italic') || htmlContent.includes('<i>') || htmlContent.includes('<em>');
}
//# sourceMappingURL=fonts.js.map